import React, { useEffect, useState } from 'react'
import { Modal, Table, Tabs, notification } from 'antd';
import TabPane from 'antd/es/tabs/TabPane';
import { useDispatch, useSelector } from 'react-redux';
import { approveRejectByRM, fetchRmPendingRequest } from '../store/reducers/rmPendingRequestSlice';
import InputTextBox from '../components/InputTextBox/InputTextBox';
import Link from 'antd/es/typography/Link';
import "../styles/rmPendingRequest.css"
import Button from '../components/Buttons/Button';
import MultilineTextbox from '../components/MultilineTextbox/MultilineTextbox';
import { ColumnsType, TablePaginationConfig } from 'antd/es/table';
import { pendingRequest_data, rejectedApiMessage } from '../utilities/CommonHelper';
import LoadingComp from '../utilities/LoadingComp';

interface RequestData {
  id: number;
  type: string;
  employeeName: string;
  employeeEmail: string;
  employeeId: string;
  businessUnit: string;
  department: string;
  reportingManagerName: string;
  reportingManagerEmail: string;
  role: string;
  accessReason: string;
  reminderEmailCount: number;
  requestStatus: string;
  approvalRejects: any[];
}


const RmPendingRequest : React.FC=()=> {

  const [activetab,setactiveTab]=React.useState<string>('1');
  const rmRequest= useSelector((state: any) => state.rmPendingRequest);
  const [requestList,setRequestList]=React.useState<any>([]);
  const dispatch =useDispatch();
  const [modalVisible, setModalVisible] = React.useState(false);
  const [selectedRecord, setSelectedRecord] = React.useState<RequestData | null>(null);
  const [rejectionReason, setRejectionReason] = React.useState('');
  const [pageNo, setPageNo] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);

  const columns : ColumnsType<RequestData>= [
  {
    title: 'Request Type',
    dataIndex: 'type',
    key: 'type',
    width: 150,
  },
  {
    title: 'Employee Name',
    dataIndex: 'employeeName',
    key: 'employeeName',
    width: 150,
  },
  {
    title: 'Employee Email',
    dataIndex: 'employeeEmail',
    key: 'employeeEmail',
    width: 150,
  },
  {
    title: 'Employee Id',
    dataIndex: 'employeeId',
    key: 'employeeId',
    width: 150,
  },
  {
    title: 'Business Unit',
    dataIndex: 'businessUnit',
    key: 'businessUnit',
    width: 150,
  },
  {
    title: 'Department',
    dataIndex: 'department',
    key: 'department',
    width: 150,
  },
  {
    title: 'Reporting Manager Name',
    dataIndex: 'reportingManagerName',
    key: 'reportingManagerName',
    width: 150,
  },
  {
    title: 'Reporting Manager Email',
    dataIndex: 'reportingManagerEmail',
    key: 'reportingManagerEmail',
    width: 150,
  },
  {
    title: 'Role',
    dataIndex: 'role',
    key: 'role',
    width: 150,
  },
  {
    title: 'Access Reason',
    dataIndex: 'accessReason',
    key: 'accessReason',
    width: 150,
  },
  {
    title: 'Request Status',
    dataIndex: 'requestStatus',
    key: 'requestStatus',
    width: 150,
  },
  {
    title: 'Actions',
    dataIndex: 'Actions',
    key: 'Actions',
    width: 150,
    fixed: 'right',
    render: (text: string, record: RequestData) => (
      <>
        <Link onClick={() => handleApprove(record)}>Approve</Link><br/>
        <Link onClick={() => handleReject(record)}>Reject</Link>
      </>
    ),
  }
  ];

  useEffect(() => { 

    console.log("RmPendingRequest page");
    dispatch(fetchRmPendingRequest({page:pageNo,size:pageSize})).then((response:any)=>{
      console.log('RmPendingRequest response',response);
      if(response.type!=='request/fetchRmPendingRequest/fulfilled'){
        rejectedApiMessage(response.payload);
      }else{
        setTotalCount(response.payload.totalElements);
    }
    });
    return () => {
      setPageNo(0);
      setPageSize(10);
      setTotalCount(0);
    }
    

  },[])

  useEffect(() => {
    console.log("rmRequest data changed",rmRequest.data);
    if(rmRequest.data!=null){
      setRequestList(rmRequest.data);
    }

  },[rmRequest.data])

  const handleApprove = (record: RequestData) => {
    let values={
      "requestId": record.id,
      "approvalLevel": "RM",
      "decision": "APPROVED",
      "reason": null
    }
    // Call the approve API with the record data
    console.log('Approving record:', record);
    dispatch(approveRejectByRM(values)).then((response:any)=>{
      if(response.type==='user/request/approveRejectByRM/fulfilled'){
        console.log('approveRejectByRM response',response);
        notification.success({
          message: 'Success',
          description: 'Request Processed Successfully',
        });
        dispatch(fetchRmPendingRequest({page:pageNo,size:pageSize})).then((res:any)=>{
          if(res.type!=='request/fetchRmPendingRequest/fulfilled'){
            rejectedApiMessage(res.payload);
          }else{
            setTotalCount(response.payload.totalElements);
        }
        });
      }
      else{
        rejectedApiMessage(response.payload);
      }
      
    })
  };

  const handleReject = (record: RequestData) => {
    setSelectedRecord(record);
    setModalVisible(true);
  };
  const handleTableChange = (pagination: TablePaginationConfig) => {
    const { current, pageSize } = pagination;
    setPageNo(current ? current - 1 : 0);
    setPageSize(pageSize || 10);
  };

  const handleModalOk = () => {
    let values={
      "requestId": selectedRecord?.id,
      "approvalLevel": "RM",
      "decision": "REJECTED",
      "reason": rejectionReason.trim()
    }
    // Call the approve API with the record data
    console.log('rejecting record:', selectedRecord);
    dispatch(approveRejectByRM(values)).then((response:any)=>{
        
      if(response.type==='user/request/approveRejectByRM/fulfilled'){
        console.log('approveRejectByRM response',response);
        notification.success({
          message: 'Success',
          description: 'Request Processed Successfully',
        });
        dispatch(fetchRmPendingRequest({page:pageNo,size:pageSize})).then((res:any)=>{
          if(res.type!=='request/fetchRmPendingRequest/fulfilled'){
            rejectedApiMessage(res.payload);
          }else{
            setTotalCount(response.payload.totalElements);
        }
        });
        console.log('Rejecting record:', selectedRecord, 'with reason:', rejectionReason);
        setModalVisible(false);
        setSelectedRecord(null);
        setRejectionReason('');
      }
      else{
        rejectedApiMessage(response.payload);
      }
    })
    // Call the reject API with the selected record and rejection reason
    
  };

  const handleModalCancel = () => {
    setModalVisible(false);
    setSelectedRecord(null);
    setRejectionReason('');
  };
  const handleValidation=()=>{
    if(rejectionReason.trim().length===0){
      return true;
    }
    return false;
  }
  

  return (
    <div className='containerr' 
    // style={{margin:'0px',padding:'0px'}}
    >
      <h2 className='page-heading'>
          Request Dashboard
        </h2>
        <div 
        className='containerr'
        style={{margin:'10px'}}
        >
        <Tabs onChange={setactiveTab}>
          <TabPane style={{font: 'normal normal normal 14px/20px Nunito Sans'}} tab="Pending Requests" key="1">
          <Table  
          className='table-style'
          loading={rmRequest.loading}
          dataSource={Array.isArray(requestList)?requestList:[]} 
          scroll={{ x: 'max-content',y:400 }}
          columns={columns}
          pagination={{
            current: pageNo + 1,
            pageSize,
            total: totalCount,
          }}
          onChange={handleTableChange} />
          </TabPane>
        </Tabs>
        </div>
        <Modal
        title="Reject Request"
        open={modalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        footer={()=>{
          return(
            <div style={{display:'flex',justifyContent:'flex-end'}}>
              <Button type='cancel' label='Cancel' onClick={handleModalCancel}></Button>
              <Button type='submit' label='Reject' disabled={handleValidation()} onClick={handleModalOk}></Button>
            </div>
          )
        
        }}
        styles={{
          content: {
            borderRadius: '0',
            borderTop: '4px solid #1677ff',
            font: 'normal normal normal 14px/20px Nunito Sans'
          },
        }}
      >
        <MultilineTextbox
          id='reason'
          label='Reason for Rejection'
          key='reasonForRejection'
          placeholder="Enter reason for rejection"
          value={rejectionReason}
          width='200px'
          onChange={(id:string,newvalue:string,oldvalue:string|null) => setRejectionReason(newvalue)}
        />
      </Modal>
      {/* <Modal
          open={rmRequest.loading}
          footer={null}
        //   centered
        closeIcon={false}
        
          styles={{
            content: {
                width: '1000px',
                height: '604px',
                top: '-50%',
                left: '-50%',
                borderRadius: '0',
                zIndex: '9999',
            }
          }
          }
        >
          <LoadingComp/>
        </Modal> */}
    </div>
  )
}
export default RmPendingRequest;